import CloseIcon from '@mui/icons-material/Close';
import { Alert, AlertProps, IconButton, SnackbarProps } from '@mui/material';
import { useEffect } from 'react';

export type ToastProps = Pick<SnackbarProps, 'children' | 'title' | 'message' | 'open'> &
  Pick<AlertProps, 'severity'> & {
    autoHideDuration?: number;
    onClose?: () => void;
  };

export const Toast = (props: ToastProps) => {
  const {
    message,
    title,
    autoHideDuration = 5000,
    onClose = () => null,
    severity = 'error',
  } = props;

  useEffect(() => {
    if (autoHideDuration) {
      const timer = setTimeout(() => onClose(), autoHideDuration);
      return () => clearTimeout(timer);
    }
  }, [autoHideDuration, onClose]);

  return (
    <Alert
      severity={severity}
      title={title}
      sx={{ mb: 2, minWidth: 200, maxWidth: { xs: 'auto', md: 400 } }}
      elevation={4}
      action={
        <IconButton size='small' aria-label='close' color='inherit' onClick={onClose}>
          <CloseIcon fontSize='small' />
        </IconButton>
      }
    >
      {message}
    </Alert>
  );
};
